import request from '@/service/request'

export const getServiceList = (params: {category: string}) => {
  return request<SERVICE.ResponsePage<HOME.SERVER[]>>({
    url: '/admin/mp-project',
    method: 'GET',
    params
  })
}

export const addService = (data: HOME.SERVER) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/mp-project',
    method: 'POST',
    data
  })
}

export const updateService = (data: HOME.SERVER) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/mp-project/${data.id}`,
    method: 'PUT',
    data
  })
}

export const getServiceById = (id: string) => {
  return request<SERVICE.Response<HOME.CITY>>({
    url: `/admin/mp-project/${id}`,
    method: 'GET'
  })
}

export const delServiceById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/mp-project/${id}`,
    method: 'DELETE'
  })
}

export const updateProjectOrderNoticeImg = (projectId: string, url: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/mp-project/${projectId}/orderNoticeImg?url=${url}`,
    method: 'PUT'
  })
}
